import React from 'react'
import { graphql } from 'gatsby'
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews'
import { GatsbyImage } from 'gatsby-plugin-image'
import { PrismicLink } from '@prismicio/react'
import { PrismicRichText } from '@prismicio/react'

// Components
import Layout from '../components/layout'
import Seo from '../components/seo'
import SliceList from '../components/sliceList'
import Support from '../components/support'

export const query = graphql`
  query Page($id: String) {
    prismicPage(id: { eq: $id }) {
      ...PrismicPageFragment
    }
  }
`
const PageTemplate = ({ data, location }) => {
  const page = data.prismicPage
  const pageData = page.data

  return (
    <Layout location={location}>
      <div className='sm:mb-10 relative hero bg-gray-800'>
        <div className={`h-full w-full max-w-screen-xl mx-auto ${pageData.page_image.gatsbyImageData && 'grid md:grid-cols-2 md:gap-4'}`}>
          <div className='px-8 xl:px-0 z-10 flex flex-col items-center justify-center md:pb-24 md:pt-32 lg:pt-48 pb-12 pt-36 sm:items-start sm:pb-20 sm:text-left space-y-8 text-center text-white'>
            <div className='drop-shadow'>
              <PrismicRichText field={pageData.page_title.richText} />
            </div>
            <div className='prose text-white prose-xl min-w-full dark:prose-invert drop-shadow'>
              <PrismicRichText field={pageData.page_text.richText} />
            </div>
            {pageData.page_button_link && (
              <PrismicLink className='button button-lg hover:bg-fuchsia-800' field={pageData.page_button_link}>
                {pageData.page_button_text}
              </PrismicLink>
            )}
          </div>
          {pageData.page_image.gatsbyImageData && (
            <div className='flex-1 z-0'>
              <div className='sm:absolute right-0 top-0 bottom-0 sm:w-1/2'>
                <GatsbyImage image={pageData.page_image.gatsbyImageData} className='mask relative overflow-hidden sm:object-fill h-full w-full' alt={pageData.page_image.alt} loading='eager' />
              </div>
            </div>
          )}
        </div>
      </div>
      {page.uid === 'support' && (
        <div className='mx-auto text-center flex flex-row w-full rounded items-center justify-center'>
          <Support />
        </div>
      )}
      <SliceList slices={pageData.body} />
    </Layout>
  )
}

export default withPrismicPreview(PageTemplate)

export const Head = ({ data, location }) => {
  const pageData = data.prismicPage.data
  return <Seo pathname={location.pathname} title={pageData.meta_title ? pageData.meta_title : pageData.title} description={pageData.meta_description} image={pageData.page_image.url} />
}
